import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // About section
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/about/why-law',
    name: 'why-law',
    component: () => import('../views/WhyLawView.vue')
  },
  {
    path: '/about/governance',
    name: 'governance',
    component: () => import('../views/GovernanceView.vue')
  },
  {
    path: '/about/emerging-leaders',
    name: 'emerging-leaders',
    component: () => import('../views/EmergingLeadersView.vue')
  },
  // Member Firms
  {
    path: '/find-a-firm',
    name: 'find-firm',
    component: () => import('../views/SearchView.vue')
  },
  {
    path: '/member-directory',
    name: 'member-directory',
    component: () => import('../views/SearchView.vue')
  },
  {
    path: '/firms/:slug',
    name: 'firm-detail',
    component: () => import('../views/LawyerDetailView.vue')
  },
  {
    path: '/lawyer/:id',
    name: 'lawyer-detail',
    component: () => import('../views/LawyerDetailView.vue')
  },
  // Practice Groups
  {
    path: '/practice-groups',
    name: 'practice-groups',
    component: () => import('../views/PracticeGroupsView.vue')
  },
  // Join LAW
  {
    path: '/join-law',
    name: 'join-law',
    component: () => import('../views/JoinView.vue')
  },
  {
    path: '/join-law/membership-criteria',
    name: 'membership-criteria',
    component: () => import('../views/MembershipCriteriaView.vue')
  },
  {
    path: '/join-law/membership-benefits',
    name: 'membership-benefits',
    component: () => import('../views/MembershipBenefitsView.vue')
  },
  {
    path: '/join-law/request-info',
    name: 'request-info',
    component: () => import('../views/JoinView.vue')
  },
  // News & Meetings
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/ResourcesView.vue')
  },
  {
    path: '/news/:slug',
    name: 'news-detail',
    component: () => import('../views/ResourcesView.vue')
  },
  {
    path: '/meetings',
    name: 'meetings',
    component: () => import('../views/MeetingsView.vue')
  },
  // Contact
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  // Auth
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  // Legal
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/TermsView.vue')
  },
  // 404
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

// Navigation guards
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token')

  if (to.meta.requiresAuth && !token) {
    return next({ name: 'login', query: { redirect: to.fullPath } })
  }

  // Admin-only routes: gate on the stored user's role.
  // (The backend also enforces this via adminAuth — this is just UX defense in depth.)
  if (to.meta.requiresAdmin) {
    let role = null
    try {
      const stored = localStorage.getItem('user') || sessionStorage.getItem('user')
      role = stored ? JSON.parse(stored).role : null
    } catch (e) {
      role = null
    }
    if (role !== 'admin') {
      return next({ name: 'home' })
    }
  }

  next()
})

export default router
